import React from "react";
import Footer from "../common/Footer/Footer";
import Menu from "../common/Menu/Menu";
import Gallery from "./Gallery";
import TopAbout from "./TopAbout";
import HomeSlider from "./HomeSlider";
import Services from "../HomeTwo/Services";

const Home = () => {
  return (
    <>
      <Menu />
      <HomeSlider />
      <TopAbout />
      {/* <TopCtaArea /> */}
      <Gallery />
      {/* <Team /> */}
      {/* <Feature /> */}
      {/* <Testimonial /> */}
      {/* <Brands /> */}
      {/* <LastedBlog /> */}
      {/* <FullScreenBtn /> */}
      {/* <TopFooter /> */}
      <Services />
      <Footer />
    </>
  );
};

export default Home;
